// extracted by mini-css-extract-plugin
export default {"label":"DatePickerSelection__label--LgtZ6","error":"DatePickerSelection__error--ZnEkm","textValue":"DatePickerSelection__textValue--BoMfp"};